export default "__VITE_ASSET__OGWX9872__"